import { environment } from '@/environments/environment';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { RegistroAvance } from '@/app/models/interface/registro-avance.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class RegistroAvanceService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'registro-avance/';

  create(formData: FormData) {
    const dir = this.url;
    return this.http.post<CustomResponse<RegistroAvance>>(dir, formData).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        return data.result;
      }),
    );
  }
}
